<template>
  <div class="e2-container-full">
    <div v-if="$slots.header"
      class="e2-container-full__header"
      ref="header">
      <slot name="header" />
    </div>
    <div class="e2-container-full__body"
      ref="body">
      <a-spin :spinning="pageLoading"
        :delay="delayTime">
        <slot/>
      </a-spin>
    </div>
    <div v-if="$slots.footer"
      class="e2-container-full__footer"
      ref="footer">
      <slot name="footer" />
    </div>
    <!-- toTop -->
    <a-back-top :target="topTarget"
      :visibilityHeight="200"
      style="right:20px;bottom:20px;" />
  </div>
</template>

<script>
import normal from './mixins/normal';

export default {
  name: 'e2-container-normal',
  mixins: [normal],
};
</script>
